const initialState = {
  frequentlyUsed: [],
  myTemplates: [],
  webId: null,
  activeTab: 'frequentlyUsed',
  lastUpdateTs: null,
};

export default function domesticBookingTemplateReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case 'SET_DOMESTIC_BOOKING_TEMPLATE_RESULT':
      return {
        ...state,
        ...action.payload,
        lastUpdateTs: new Date(),
      };
    case 'SET_DOMESTIC_BOOKING_TEMPLATE_TAB':
      return { ...state, activeTab: action.payload };
    case 'RESET_DOMESTIC_BOOKING_TEMPLATE':
      return initialState;
    default:
      return state;
  }
}
